(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5740],{

/***/ 78330:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/generated-templates/one-pager-asset-template-page",
      function () {
        return __webpack_require__(44353);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 14900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ accessibility_statement_link_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./static/svg/accessibility/accessibility_icon6.svg
var _path, _circle, _circle2;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgAccessibilityIcon6 = function SvgAccessibilityIcon6(props) {
    return /*#__PURE__*/ react.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 21,
        height: 21,
        fill: "none",
        viewBox: "0 0 21 21"
    }, props), _path || (_path = /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.2,
        d: "m6 8 4.035.913v3.155L8.142 17M15.216 8l-4.035.913v3.155L13.074 17"
    })), _circle || (_circle = /*#__PURE__*/ react.createElement("circle", {
        cx: 10.5,
        cy: 10.5,
        r: 9.5,
        stroke: "#000",
        strokeLinecap: "round"
    })), _circle2 || (_circle2 = /*#__PURE__*/ react.createElement("circle", {
        cx: 10.5,
        cy: 5.5,
        r: 1.5,
        stroke: "#000"
    })));
};
/* harmony default export */ var accessibility_icon6 = (SvgAccessibilityIcon6);

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./components/accessibility/accessibility-statement-link/accessibility-statement-link-component.scss.js


var StyledAccessibilityStatementLinkComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e97kqcm0"
})("display:flex;font-size:0.75rem;cursor:pointer;.accessibility-icon-wrapper{display:flex;.accessibility-icon{circle,path{color:", colors/* default.text-gray */.Z["text-gray"], ";transition:stroke 150ms ease;}}}.accessibility-link-wrapper{padding-left:8px;display:flex;align-items:center;.accessibility-link{transition:150ms color ease;color:", colors/* default.text-gray */.Z["text-gray"], ";}}&:hover{.accessibility-icon-wrapper{.accessibility-icon{path,circle{stroke:", colors/* default.iris */.Z.iris, ";}}}.accessibility-link-wrapper{.accessibility-link{color:", colors/* default.iris */.Z.iris, ";}}}");

;// CONCATENATED MODULE: ./components/accessibility/accessibility-statement-link/accessibility-statement-link-component.js





var AccessibilityStatementLinkComponent = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledAccessibilityStatementLinkComponent, {
        className: "accessibilty-statement-link-component",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "accessibility-icon-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(accessibility_icon6, {
                    className: "accessibility-icon"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "accessibility-link-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: links/* ACCESSIBILITY_STATEMENT_LINK */.eY0,
                    className: "accessibility-link",
                    children: props.translate("footer.accessibiltyStatement")
                })
            })
        ]
    });
};
/* harmony default export */ var accessibility_statement_link_component = ((0,generic_config_context/* withGenericConfig */.P)(AccessibilityStatementLinkComponent));


/***/ }),

/***/ 44133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AssetPartComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/video/video-component.js + 1 modules
var video_component = __webpack_require__(3773);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./components/core/one-pager/asset-part/asset-part-component.scss.js

var _defaultExport = new String(".asset-part-component.jsx-66cf28cb47c773ef{width:100%;height:100%;video {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n\n    &.half-width {\n      display: flex;\n      justify-content: flex-end;\n    }\n  }");
_defaultExport.__hash = "66cf28cb47c773ef";
/* harmony default export */ var asset_part_component_scss = (_defaultExport);

;// CONCATENATED MODULE: ./components/core/one-pager/asset-part/asset-part-component.js









var AssetPartComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(AssetPartComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(AssetPartComponent);
    function AssetPartComponent() {
        (0,_class_call_check/* default */.Z)(this, AssetPartComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(AssetPartComponent, [
        {
            key: "getVideoType",
            value: function getVideoType(videoUrl) {
                return videoUrl.split(".").pop();
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, playsInline = _props.playsInline, autoPlay = _props.autoPlay, muted = _props.muted, loop = _props.loop, theme = _props.theme;
                var _assetProps = this.props.assetProps, formats = _assetProps.formats, poster = _assetProps.poster;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(asset_part_component_scss.__hash) + " " + "asset-part-component ".concat(theme),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(video_component/* default */.Z, {
                            formats: formats,
                            loop: loop,
                            muted: muted,
                            poster: poster,
                            playsInline: playsInline,
                            autoPlay: autoPlay
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: asset_part_component_scss.__hash,
                            children: asset_part_component_scss
                        })
                    ]
                });
            }
        }
    ]);
    return AssetPartComponent;
}(react.PureComponent);

AssetPartComponent.defaultProps = {
    playsInline: true,
    autoPlay: true,
    muted: true,
    loop: true
};


/***/ }),

/***/ 69861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ short_footer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./components/core/language-picker/language-picker-component.js + 6 modules
var language_picker_component = __webpack_require__(39160);
// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/footer-bottom-bar/palette-icons/palette-icons-component.js + 3 modules
var palette_icons_component = __webpack_require__(87917);
// EXTERNAL MODULE: ./client/services/cluster-config-service/cluster-config-service.js
var cluster_config_service = __webpack_require__(79092);
// EXTERNAL MODULE: ./components/core/language-picker/language-picker-service.js
var language_picker_service = __webpack_require__(42803);
// EXTERNAL MODULE: ./components/core/picture-with-link/picture-with-link-component.js
var picture_with_link_component = __webpack_require__(94640);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./constants/work-managment-logos.js
var work_managment_logos = __webpack_require__(74329);
;// CONCATENATED MODULE: ./components/core/short-footer/short-footer-service.js



var TITLE_TYPE = {
    MAIN: "MAIN",
    MAIN_CLICKABLE: "MAIN_CLICKABLE",
    SECONDARY: "SECONDARY",
    LINK: "LINK"
};
var PRODUCTS_LINKS = [
    {
        title: "header.products",
        type: TITLE_TYPE.MAIN
    },
    {
        title: "header.tabs.solutions.byProduct.workManagement",
        url: links/* WORK_MANAGEMENT_MINI_SITE_LINK */.ler,
        icon: work_managment_logos/* default.WM_FOOTER_LOGO */.Z.WM_FOOTER_LOGO,
        type: TITLE_TYPE.LINK
    },
    {
        title: "header.tabs.products.mondaySalesCRM.newLayout.topic",
        url: links/* CRM_MINI_SITE_LINK */.mgz,
        icon: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/footer/crm_icon_footer.png",
        type: TITLE_TYPE.LINK
    },
    {
        title: "header.tabs.products.mondayDev.newLayout.topic",
        url: links/* SOFTWARE_MINI_SITE_LINK */.DDD,
        icon: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/footer/dev_new_mobile_footer_logo.png",
        type: TITLE_TYPE.LINK
    },
    {
        title: "header.tabs.products.mondayService.newLayout.topic",
        url: links/* SERVICE_MINI_SITE_LINK */.Kon,
        icon: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/Yotam_Ron/service/Service-logo-footer.png",
        type: TITLE_TYPE.LINK,
        hasBetaTag: true
    }
];
var FEATURES_LINKS = [
    {
        title: "footer.features",
        type: TITLE_TYPE.MAIN
    },
    {
        title: "footer.dashboard",
        url: links/* DASHBOARDS_PAGE_LINK */.yCu,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.integrations",
        url: links/* INTEGRATIONS_PAGE_LINK */.oUX,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.automations",
        url: links/* AUTOMATIONS_PAGE_LINK */.cPO,
        type: TITLE_TYPE.LINK
    },
    {
        title: "header.tabs.product.gantt.title",
        url: links/* GANTT_PAGE_LINK */.TA3,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.kanban",
        url: links/* KANBAN_PAGE_LINK */.ivN,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.workdocs",
        url: links/* WORKDOCS_PAGE_LINK */.RdE,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.ai",
        url: links/* AI_PAGE_LINK */.lro,
        type: TITLE_TYPE.LINK
    },
    {
        title: "header.tabs.features.keyFeatures.forms.title",
        url: links/* FORMS_PAGE_LINK */.ua2,
        type: TITLE_TYPE.LINK
    }
];
var COMPANY_LINKS = [
    {
        title: "footer.ourTeam",
        type: TITLE_TYPE.MAIN
    },
    {
        title: "footer.aboutUs",
        url: links/* ABOUT_US_PAGE_LINK */.iAZ,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.careers",
        url: links/* CAREERS_PAGE_LINK */.sb2,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.investorRelations",
        url: links/* INVESTOR_RELATIONS_LINK */.ObI,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.partners",
        url: links/* PARTNERS_PAGE_LINK */.MW2,
        type: TITLE_TYPE.LINK
    }
];
var RESOURCES_LINKS = [
    {
        title: "footer.resources",
        type: TITLE_TYPE.MAIN
    },
    {
        title: "footer.blog",
        url: links/* BLOG_PAGE_LINK */.xR0,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.whatsNew",
        url: links/* WHATS_NEW_PAGE_LINK */.Lmq,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.mondaySpaces",
        url: links/* MONDAY_SPACES_PAGE_LINK */.UN3,
        type: TITLE_TYPE.LINK
    }
];
var TEAM_TYPE_LINKS = [
    {
        title: "footer.projectManagement",
        url: links/* WORK_MANAGEMENT_FOR_PMO_MINI_SITE_LINK */.Y42,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.marketing",
        url: links/* WORK_MANAGEMENT_FOR_MARKETING_MINI_SITE_LINK */.qAD,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.salesUseCase",
        url: links/* CRM_MINI_SITE_LINK */.mgz,
        type: TITLE_TYPE.LINK
    },
    {
        title: "header.tabs.solutions.byTeam.developers.title",
        url: links/* SOFTWARE_MINI_SITE_LINK */.DDD,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.operations",
        url: links/* OPERATIONS_CLUSTER_LINK */.R9t,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.itOperations",
        url: links/* SERVICE_MINI_SITE_LINK */.Kon,
        type: TITLE_TYPE.LINK
    },
    {
        title: "footer.hr",
        url: links/* HR_USE_CASES_LINK */.n$n,
        type: TITLE_TYPE.LINK
    }
];
var COMPANY_SIZE_LINKS = [
    {
        title: "header.tabs.solutions.byTeam.companySize",
        type: TITLE_TYPE.MAIN
    },
    {
        title: "footer.enterprise",
        url: links/* ENTERPRISE_PAGE_LINK */.RVF,
        type: TITLE_TYPE.LINK
    },
    {
        title: "header.tabs.workflows.byBusinessSize.smallBusiness",
        url: links/* SMB_PAGE_LINK */.qDl,
        type: TITLE_TYPE.LINK
    },
    {
        title: "header.tabs.workflows.byBusinessSize.nonprofit",
        url: links/* NGO_PAGE_LINK */.htU,
        type: TITLE_TYPE.LINK
    }
];
var TEAMS_LINKS = [
    {
        title: "header.teams",
        type: TITLE_TYPE.MAIN
    }
].concat((0,_to_consumable_array/* default */.Z)(TEAM_TYPE_LINKS), (0,_to_consumable_array/* default */.Z)(COMPANY_SIZE_LINKS));
var LINKS_DATA_COLUMNS = (0,_to_consumable_array/* default */.Z)(PRODUCTS_LINKS).concat((0,_to_consumable_array/* default */.Z)(FEATURES_LINKS), (0,_to_consumable_array/* default */.Z)(COMPANY_LINKS), (0,_to_consumable_array/* default */.Z)(RESOURCES_LINKS), (0,_to_consumable_array/* default */.Z)(TEAMS_LINKS), [
    {
        title: "footer.pricing",
        url: links/* PRICING_PAGE_LINK */.C9V,
        type: TITLE_TYPE.MAIN_CLICKABLE
    },
    {
        title: "footer.contactSales",
        isClickable: true,
        url: links/* CONTACT_SALES_FROM_FOOTER_PAGE_LINK */.vMu,
        type: TITLE_TYPE.MAIN_CLICKABLE
    },
    {
        title: "footer.contactUs",
        isClickable: true,
        url: links/* CONTACT_US_PAGE_LINK */.nO,
        type: TITLE_TYPE.MAIN_CLICKABLE
    }
]);

// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./components/core/short-footer/short-footer-link/short-footer-link.scss.js



var StyledShortFooterLink = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", {
    target: "ekk5iqg0"
})("text-decoration:none;cursor:default;width:fit-content;color:", colors/* default.black */.Z.black, ";line-height:12px;display:flex;align-items:center;gap:4px;transition:100ms color ease;.link-icon{height:12px;width:12px;}&.main-title{font-weight:600;font-size:0.875rem;&.clickable{text-decoration:underline;cursor:pointer;}}&.secondary-title{font-weight:600;color:", colors/* default.asphalt */.Z.asphalt, ";font-size:0.75rem;}&.link{font-weight:400;font-size:0.75rem;cursor:pointer;&:hover{color:", colors/* default */.Z[color_consts.IRIS_COLOR_NAME], ";}}.beta-tag{font-size:0.6875rem;font-weight:400;color:", colors/* default */.Z[color_consts.BRAND_SERVICE_PRIMARY_COLOR_NAME], ";background-color:", colors/* default */.Z[color_consts.LIGHT_BACKGROUND_PINK], ";border-radius:12px;padding:1px 5px;line-height:normal;border-radius:32px;}");

;// CONCATENATED MODULE: ./components/core/short-footer/short-footer-link/short-footer-link.js












var _obj;
var LINK_TYPE_TO_CLASS_NAME = (_obj = {}, (0,_define_property/* default */.Z)(_obj, TITLE_TYPE.MAIN, "main-title"), (0,_define_property/* default */.Z)(_obj, TITLE_TYPE.MAIN_CLICKABLE, "main-title clickable"), (0,_define_property/* default */.Z)(_obj, TITLE_TYPE.SECONDARY, "secondary-title"), (0,_define_property/* default */.Z)(_obj, TITLE_TYPE.LINK, "link"), _obj);
var ShortFooterLink = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ShortFooterLink, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ShortFooterLink);
    function ShortFooterLink(props) {
        (0,_class_call_check/* default */.Z)(this, ShortFooterLink);
        return _super.call(this, props);
    }
    (0,_create_class/* default */.Z)(ShortFooterLink, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, title = _props.title, url = _props.url, translate = _props.translate, type = _props.type, icon = _props.icon, hasBetaTag = _props.hasBetaTag;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledShortFooterLink, {
                    className: classnames_default()("short-footer-link-component", LINK_TYPE_TO_CLASS_NAME[type]),
                    href: url,
                    children: [
                        icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                            className: "link-icon",
                            src: icon,
                            alt: translate(title)
                        }),
                        translate(title),
                        hasBetaTag && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "beta-tag",
                            children: translate("header.tabs.solutions.byProduct.dev.beta")
                        })
                    ]
                });
            }
        }
    ]);
    return ShortFooterLink;
}(react.PureComponent);
/* harmony default export */ var short_footer_link = ((0,generic_config_context/* withGenericConfig */.P)(ShortFooterLink));

// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/core/short-footer/short-footer.scss.js



var StyledShortFooter = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("footer", {
    target: "e1n3z9yf0"
})("color:", colors/* default.black */.Z.black, ";display:flex;flex-direction:column;align-items:center;padding:48px 80px;justify-content:center;.short-footer-header{width:100%;justify-content:space-between;display:flex;margin-bottom:48px;flex-direction:row;.language-picker-wrapper-component{width:120px;.language-picker-component{.language-picker-dialog-component-wrapper{margin:0;}}}}.short-footer-links{width:100%;column-count:4;flex-wrap:wrap;.link-wrapper{flex-basis:100%;break-inside:avoid;margin:0 0 20px;&.main:not(:first-child){margin-top:28px;}&.main:nth-child(15n),&.main:nth-child(24n),&.main:nth-child(36n){break-before:column;margin-top:0;}}}.bottom{display:flex;flex-direction:column;margin-top:32px;align-items:center;gap:12px;.terms{display:flex;gap:12px;.accessibility-statement-link-wrapper{display:flex;align-items:center;}}.footer-link{display:flex;align-items:center;text-decoration:underline;a{transition:150ms color ease;color:", colors/* default.text-gray */.Z["text-gray"], ";font-size:0.75rem;}}}.monday-logo-wrapper{.footer-monday-logo-image{height:32px;}}.contact-info-wrapper{font-size:0.8125rem;text-align:center;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){align-items:initial;padding:32px;.short-footer-links{column-count:2;flex-wrap:wrap;.link-wrapper{&.main:nth-child(15n),&.main:nth-child(36n){break-before:auto;margin-top:28px;}}}.bottom{align-items:initial;.contact-info-wrapper{text-align:left;width:100%;line-height:24px;.address-info{margin-top:0;}}.social-proof-wrapper{width:100%;.palette-icons-container{margin-top:0;}.icons-wrapper{margin:0 !important;}}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MIN_WIDTH */.Lk, "){.terms{flex-wrap:wrap;.accessibility-statement-link-wrapper{flex-basis:100%;}}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, ") and (min-width:", vp_sizes/* MOBILE_QUERY_MIN_WIDTH */.Lk, "){align-items:center;.short-footer-links{column-count:3;flex-wrap:wrap;.link-wrapper{&.main:nth-child(36n){break-before:column;margin-top:0;}}}.bottom{width:100%;align-items:center;justify-content:center;.contact-info-wrapper{text-align:center;}.social-proof-wrapper{display:flex;align-items:center;justify-content:center;.icons-wrapper{width:fit-content;}}}}}");

// EXTERNAL MODULE: ./components/accessibility/accessibility-statement-link/accessibility-statement-link-component.js + 2 modules
var accessibility_statement_link_component = __webpack_require__(14900);
// EXTERNAL MODULE: ./constants/localization.js
var localization = __webpack_require__(72632);
;// CONCATENATED MODULE: ./components/core/short-footer/short-footer.js





function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}















var short_footer_obj;
var TITLE_TYPE_TO_CLASS_NAME = (short_footer_obj = {}, (0,_define_property/* default */.Z)(short_footer_obj, TITLE_TYPE.MAIN, "main"), (0,_define_property/* default */.Z)(short_footer_obj, TITLE_TYPE.MAIN_CLICKABLE, "main standalone"), (0,_define_property/* default */.Z)(short_footer_obj, TITLE_TYPE.SECONDARY, "secondary"), (0,_define_property/* default */.Z)(short_footer_obj, TITLE_TYPE.LINK, "item"), short_footer_obj);
var ShortFooter = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ShortFooter, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ShortFooter);
    function ShortFooter(props) {
        (0,_class_call_check/* default */.Z)(this, ShortFooter);
        return _super.call(this, props);
    }
    (0,_create_class/* default */.Z)(ShortFooter, [
        {
            key: "renderLinks",
            value: function renderLinks() {
                var _props = this.props, localeId = _props.localeId, pageClusterConfig = _props.pageClusterConfig, useProductMiniSiteConfig = _props.useProductMiniSiteConfig;
                var links = LINKS_DATA_COLUMNS;
                if (pageClusterConfig) {
                    (0,cluster_config_service/* updateClusterShortFooterLinks */.j8)(pageClusterConfig, links, {
                        useProductMiniSiteConfig: useProductMiniSiteConfig
                    });
                }
                return links.map(function(link) {
                    var title = link.title, type = link.type;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("short-footer-link-component-wrapper", "link-wrapper", (0,_define_property/* default */.Z)({}, TITLE_TYPE_TO_CLASS_NAME[type], type)),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(short_footer_link, _object_spread({
                            localeId: localeId
                        }, link))
                    }, title);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, translate = _props.translate, localeId = _props.localeId;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledShortFooter, {
                    className: "short-footer-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "short-footer-header",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "monday-logo-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_with_link_component/* default */.Z, {
                                        src: links/* MONDAY_LOGO_SRC */.Onk,
                                        className: "footer-monday-logo-image",
                                        href: links/* ROOT_LINK */.yjY,
                                        alt: "monday logo"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "language-picker-wrapper-component link-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(language_picker_component/* default */.Z, {
                                        dialogDirection: language_picker_service/* DIALOG_DIRECTIONS.ALIGN_BOTTOM */.Df.ALIGN_BOTTOM
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "short-footer-links",
                            children: this.renderLinks()
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "bottom",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "contact-info-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "all-right-reserved-info",
                                        children: [
                                            translate("allRightsReserved"),
                                            " \xa9 monday.com"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "social-proof-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(palette_icons_component/* default */.Z, {
                                        SocialFooterLinks: links/* SocialFooterLinks */.Ff7
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "terms",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "accessibility-statement-link-wrapper link-wrapper",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(accessibility_statement_link_component/* default */.Z, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "footer-link",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: links/* PRIVACY_POLICY_LINK */.jbE,
                                                children: translate("footer.termsAndPrivacy")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "footer-link",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                "data-footer-link-type": "cookie-settings",
                                                onClick: function() {
                                                    var _window_cookiehub, _window;
                                                    return (_window = window) === null || _window === void 0 ? void 0 : (_window_cookiehub = _window.cookiehub) === null || _window_cookiehub === void 0 ? void 0 : _window_cookiehub.openSettings();
                                                },
                                                children: translate("footer.yourPrivacyChoices")
                                            })
                                        }),
                                        localeId === localization.GERMAN_LOCALE_ID && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "footer-link",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: links/* IMPRESSUM_LINK */.YSM,
                                                children: translate("footer.impressum")
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return ShortFooter;
}(react.PureComponent);
/* harmony default export */ var short_footer = ((0,generic_config_context/* withGenericConfig */.P)(ShortFooter));


/***/ }),

/***/ 73418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hamburger_menu_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./components/core/top-bar-new/hamburger-menu/hamburger-menu-component.scss.js



var StyledHamburgerMenuComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e10ajo1f0"
})("width:28px;transform:rotate(0deg);cursor:pointer;z-index:", z_index/* SIDE_NAV */.gR + 1, ";margin-left:24px;margin-right:8px;height:36px;display:flex;.hamburger-menu-line{display:block;position:absolute;height:3px;width:100%;background-color:", colors/* default.black */.Z.black, ";border-radius:4px;opacity:1;left:0;transform:rotate(0deg);transition:all 0.2s ease-in-out;&:nth-child(1){top:8px;}&:nth-child(2),&:nth-child(3){top:17px;}&:nth-child(4){top:26px;}}&.open{.hamburger-menu-line{background-color:", colors/* default.black */.Z.black, ";&:nth-child(1){top:18px;width:0%;left:50%;}&:nth-child(2){transform:rotate(45deg);}&:nth-child(3){transform:rotate(-45deg);}&:nth-child(4){top:18px;width:0;left:50%;}}}");

;// CONCATENATED MODULE: ./components/core/top-bar-new/hamburger-menu/hamburger-menu-component.js










var HamburgerMenuComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(HamburgerMenuComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(HamburgerMenuComponent);
    function HamburgerMenuComponent(props) {
        (0,_class_call_check/* default */.Z)(this, HamburgerMenuComponent);
        var _this;
        _this = _super.call(this, props);
        _this.toggleOpenState = _this.toggleOpenState.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.onKeyDown = (0,accessibility_service/* generateOnKeyDownHandler */.vR)(_this.toggleOpenState);
        return _this;
    }
    (0,_create_class/* default */.Z)(HamburgerMenuComponent, [
        {
            key: "toggleOpenState",
            value: function toggleOpenState() {
                var isOpen = this.props.isOpen;
                this.props.changeStateCallback(!isOpen);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, theme = _props.theme, isInScrollMode = _props.isInScrollMode, isOpen = _props.isOpen, translate = _props.translate;
                var scrollModeClass = isInScrollMode ? "scroll-mode" : "";
                var openMode = isOpen ? "open" : "";
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHamburgerMenuComponent, {
                    className: "hamburger-menu ".concat(theme, " ").concat(scrollModeClass, " ").concat(openMode),
                    tabIndex: 0,
                    onClick: this.toggleOpenState,
                    onKeyDown: this.onKeyDown,
                    onMouseDown: accessibility_service/* preventFocusOnMouseDown */.$R,
                    "aria-label": isOpen ? translate("header.closeMenu") : translate("header.openMenu"),
                    "aria-haspopup": "menu",
                    "aria-expanded": isOpen,
                    role: "button",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "hamburger-menu-line"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "hamburger-menu-line"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "hamburger-menu-line"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "hamburger-menu-line"
                        })
                    ]
                });
            }
        }
    ]);
    return HamburgerMenuComponent;
}(react.PureComponent);
HamburgerMenuComponent.defaultProps = {
    changeStateCallback: function() {},
    isInScrollMode: false,
    theme: "",
    isOpen: false
};
/* harmony default export */ var hamburger_menu_component = ((0,generic_config_context/* withGenericConfig */.P)(HamburgerMenuComponent));


/***/ }),

/***/ 87355:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ OnePagerAssetTemplate; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/top-bar-new/top-bar-component.js + 33 modules
var top_bar_component = __webpack_require__(21882);
// EXTERNAL MODULE: ./components/addons/core-addons/core-addons-component.js + 8 modules
var core_addons_component = __webpack_require__(48124);
// EXTERNAL MODULE: ./components/templates/base-template.js + 45 modules
var base_template = __webpack_require__(45338);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/core/one-pager/asset-part/asset-part-component.js + 1 modules
var asset_part_component = __webpack_require__(44133);
// EXTERNAL MODULE: ./components/core/one-pager/desktop-content/text-part/text-part-component.js + 5 modules
var text_part_component = __webpack_require__(63126);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/templates/one-pager-asset-template/one-pager-asset-content/desktop-content/desktop-content-component.scss.js


var StyledDesktopContentComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e44zhjk0"
})("height:100%;.asset-part-wrapper{width:100%;height:100%;}.text-part-wrapper{position:absolute;top:0;bottom:0;left:0;width:56vw;display:flex;align-items:center;padding:16px 0 16px 80px;}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.text-part-wrapper{padding:16px 0 16px 54px;}}");

;// CONCATENATED MODULE: ./components/templates/one-pager-asset-template/one-pager-asset-content/desktop-content/desktop-content-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var DesktopContentComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(DesktopContentComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(DesktopContentComponent);
    function DesktopContentComponent() {
        (0,_class_call_check/* default */.Z)(this, DesktopContentComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(DesktopContentComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, assetPart = _props.assetPart, textPart = _props.textPart, _signupForm = _props.signupForm, signupForm = _signupForm === void 0 ? {} : _signupForm, collaborationWith = _props.collaborationWith, popupVideo = _props.popupVideo, abTests = _props.abTests;
                signupForm.focusOnLoad = true;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDesktopContentComponent, {
                    className: "desktop-content-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "asset-part-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_part_component/* default */.Z, {
                                assetType: assetPart.type,
                                assetProps: assetPart.props
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-part-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_part_component/* default */.Z, _object_spread_props(_object_spread({}, textPart), {
                                signupForm: signupForm,
                                collaborationWith: collaborationWith,
                                popupVideo: popupVideo
                            }))
                        })
                    ]
                });
            }
        }
    ]);
    return DesktopContentComponent;
}(react.PureComponent);
/* harmony default export */ var desktop_content_component = ((0,ab_tests_context/* withAbTests */.k)(DesktopContentComponent));

// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./components/core/one-pager/mobile-content/text-part/text-part-component.js + 3 modules
var text_part_text_part_component = __webpack_require__(57858);
// EXTERNAL MODULE: ./services/community/url-service.js
var url_service = __webpack_require__(932);
;// CONCATENATED MODULE: ./components/core/one-pager/mobile-asset-content/mobile-asset-content-component.scss.js
var _defaultExport = new String(".mobile-asset-content-component{height:100%;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center;-webkit-background-size:cover!important;-moz-background-size:cover!important;-o-background-size:cover!important;background-size:cover!important;.text-part-component{.subtitle-lines-wrapper{margin-bottom:24px!important}}.asset-part-wrapper{-webkit-box-flex:1;-webkit-flex:1;-moz-box-flex:1;-ms-flex:1;flex:1;width:100vw;position:relative;padding-top:24px;.asset-part{width:100%;height:100%;position:absolute;-webkit-background-size:contain;-moz-background-size:contain;-o-background-size:contain;background-size:contain;background-repeat:no-repeat;background-position:center}}}");
_defaultExport.__hash = "d8c69559db605e67";
/* harmony default export */ var mobile_asset_content_component_scss = (_defaultExport);

;// CONCATENATED MODULE: ./components/core/one-pager/mobile-asset-content/mobile-asset-content-component.js




function mobile_asset_content_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function mobile_asset_content_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            mobile_asset_content_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function mobile_asset_content_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function mobile_asset_content_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        mobile_asset_content_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var MobileAssetContentComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(MobileAssetContentComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(MobileAssetContentComponent);
    function MobileAssetContentComponent() {
        (0,_class_call_check/* default */.Z)(this, MobileAssetContentComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(MobileAssetContentComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, textPart = _props.textPart, mobileAssetType = _props.mobileAssetType, signupForm = _props.signupForm, collaborationWith = _props.collaborationWith;
                collaborationWith.color = "black";
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(mobile_asset_content_component_scss.__hash) + " " + "mobile-asset-content-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(mobile_asset_content_component_scss.__hash) + " " + "text-part-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_part_text_part_component/* default */.Z, mobile_asset_content_component_object_spread_props(mobile_asset_content_component_object_spread({}, textPart), {
                                signupForm: signupForm,
                                collaborationWith: collaborationWith,
                                color: "black"
                            }))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(mobile_asset_content_component_scss.__hash) + " " + "asset-part-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    backgroundImage: "url(".concat((0,url_service.fixDevImageUrl)(mobileAssetType), ")")
                                },
                                className: "jsx-".concat(mobile_asset_content_component_scss.__hash) + " " + "asset-part"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: mobile_asset_content_component_scss.__hash,
                            children: mobile_asset_content_component_scss
                        })
                    ]
                });
            }
        }
    ]);
    return MobileAssetContentComponent;
}(react.PureComponent);

MobileAssetContentComponent.defaultProps = {
    mobileAssetType: "/static/img/one-pager/mobile/m-statuses-with-hand.gif",
    collaborationWith: {}
};

;// CONCATENATED MODULE: ./components/core/one-pager/mobile-background-gif-content/mobile-background-gif-content-component.scss.js
var mobile_background_gif_content_component_scss_defaultExport = new String(".mobile-background-gif-content-component.jsx-31f3db773df3688c{height:100%;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center;-webkit-background-size:cover!important;-moz-background-size:cover!important;-o-background-size:cover!important;background-size:cover!important;.asset-part-wrapper.jsx-31f3db773df3688c{-webkit-box-flex:1;-webkit-flex:1;-moz-box-flex:1;-ms-flex:1;flex:1;width:100vw;.asset-part.jsx-31f3db773df3688c{width:100%;height:100%;-webkit-background-size:cover!important;-moz-background-size:cover!important;-o-background-size:cover!important;background-size:cover!important;background-position:center!important}}}");
mobile_background_gif_content_component_scss_defaultExport.__hash = "31f3db773df3688c";
/* harmony default export */ var mobile_background_gif_content_component_scss = (mobile_background_gif_content_component_scss_defaultExport);

;// CONCATENATED MODULE: ./components/core/one-pager/mobile-background-gif-content/mobile-background-gif-content-component.js




function mobile_background_gif_content_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function mobile_background_gif_content_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            mobile_background_gif_content_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function mobile_background_gif_content_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function mobile_background_gif_content_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        mobile_background_gif_content_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var MobileBackgroundGifContentComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(MobileBackgroundGifContentComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(MobileBackgroundGifContentComponent);
    function MobileBackgroundGifContentComponent() {
        (0,_class_call_check/* default */.Z)(this, MobileBackgroundGifContentComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(MobileBackgroundGifContentComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, textPart = _props.textPart, backgroundAsset = _props.backgroundAsset, signupForm = _props.signupForm, collaborationWith = _props.collaborationWith;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        background: "url(".concat(backgroundAsset, ")")
                    },
                    className: "jsx-".concat(mobile_background_gif_content_component_scss.__hash) + " " + "mobile-background-gif-content-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(mobile_background_gif_content_component_scss.__hash) + " " + "text-part-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_part_text_part_component/* default */.Z, mobile_background_gif_content_component_object_spread_props(mobile_background_gif_content_component_object_spread({}, textPart), {
                                signupForm: signupForm,
                                collaborationWith: collaborationWith,
                                color: "black"
                            }))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: mobile_background_gif_content_component_scss.__hash,
                            children: mobile_background_gif_content_component_scss
                        })
                    ]
                });
            }
        }
    ]);
    return MobileBackgroundGifContentComponent;
}(react.PureComponent);

MobileBackgroundGifContentComponent.defaultProps = {
    backgroundAsset: "/static/img/one-pager/one-pager-mobile.gif",
    collaborationWith: {}
};

// EXTERNAL MODULE: ./components/segments/social-proof/social-proof-component.js + 1 modules
var social_proof_component = __webpack_require__(18925);
// EXTERNAL MODULE: ./components/segments/short-footer/short-footer-component.js
var short_footer_component = __webpack_require__(83234);
// EXTERNAL MODULE: ./constants/one-pager-asset-types.js
var one_pager_asset_types = __webpack_require__(30513);
;// CONCATENATED MODULE: ./components/templates/one-pager-asset-template/one-pager-asset-content/one-pager-asset-content-component.scss.js


var StyledOnePagerAssetContentComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ku8qxu0"
})("width:100vw;height:calc(100vh - 65px);position:relative;overflow:hidden;.desktop-content-wrapper{display:block;height:100%;}.mobile-content-wrapper{display:none;height:100%;}&.multiple-folds{overflow:visible;.desktop-content-wrapper{height:auto;.desktop-content-component{.asset-part-wrapper{.asset-part-component{.video-component{.react-player-video-component{video{width:100vw !important;height:calc(100vh - 65px) !important;object-fit:cover;}}}}}}}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){height:calc(100vh - 54px);.desktop-content-wrapper{display:none;}.mobile-content-wrapper{display:block;}}");

;// CONCATENATED MODULE: ./components/templates/one-pager-asset-template/one-pager-asset-content/one-pager-asset-content-component.js




function one_pager_asset_content_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function one_pager_asset_content_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            one_pager_asset_content_component_define_property(target, key, source[key]);
        });
    }
    return target;
}










var OnePagerAssetContentComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(OnePagerAssetContentComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(OnePagerAssetContentComponent);
    function OnePagerAssetContentComponent() {
        (0,_class_call_check/* default */.Z)(this, OnePagerAssetContentComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(OnePagerAssetContentComponent, [
        {
            key: "getMobileVersion",
            value: function getMobileVersion() {
                var mobileVersion = this.props.mobileVersion;
                if (mobileVersion === one_pager_asset_types/* MOBILE_VERSIONS.MOBILE_ASSET */.m.MOBILE_ASSET) {
                    return MobileAssetContentComponent;
                }
                return MobileBackgroundGifContentComponent;
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, SocialProof = _props.SocialProof, ShortFooter = _props.ShortFooter;
                var showSocialProof = SocialProof.showSocialProof, socialProofContent = SocialProof.content;
                var showShortFooter = ShortFooter.showShortFooter, shortFooterContent = ShortFooter.content;
                var MobileComponent = this.getMobileVersion();
                var hasMultipleFolds = showSocialProof || showShortFooter;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOnePagerAssetContentComponent, {
                    className: classnames_default()("one-pager-asset-content-component", {
                        "multiple-folds": hasMultipleFolds
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "desktop-content-wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_content_component, one_pager_asset_content_component_object_spread({}, this.props)),
                                showSocialProof && /*#__PURE__*/ (0,jsx_runtime.jsx)(social_proof_component/* default */.Z, one_pager_asset_content_component_object_spread({}, socialProofContent)),
                                showShortFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(short_footer_component/* default */.Z, one_pager_asset_content_component_object_spread({}, shortFooterContent))
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mobile-content-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileComponent, one_pager_asset_content_component_object_spread({}, this.props))
                        })
                    ]
                });
            }
        }
    ]);
    return OnePagerAssetContentComponent;
}(react.PureComponent);

OnePagerAssetContentComponent.defaultProps = {
    assetPart: {},
    textPart: {},
    collaborationWith: {},
    mobileVersion: one_pager_asset_types/* MOBILE_VERSIONS.MOBILE_BACKGROUND_GIF */.m.MOBILE_BACKGROUND_GIF,
    SocialProof: {},
    ShortFooter: {}
};

;// CONCATENATED MODULE: ./components/templates/one-pager-asset-template/one-pager-asset-template.js




function one_pager_asset_template_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function one_pager_asset_template_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            one_pager_asset_template_define_property(target, key, source[key]);
        });
    }
    return target;
}
function one_pager_asset_template_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function one_pager_asset_template_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        one_pager_asset_template_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var OnePagerAssetTemplate = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(OnePagerAssetTemplate, PureComponent);
    var _super = (0,_create_super/* default */.Z)(OnePagerAssetTemplate);
    function OnePagerAssetTemplate() {
        (0,_class_call_check/* default */.Z)(this, OnePagerAssetTemplate);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(OnePagerAssetTemplate, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, headerUrl = _props.headerUrl, exitPopup = _props.exitPopup, loginTheme = _props.loginTheme, menuTheme = _props.menuTheme, stickyMode = _props.stickyMode, pageConfig = _props.pageConfig;
                var headerStrip = pageConfig.headerStrip, parts = pageConfig.parts, footerSignup = pageConfig.footerSignup, nameSignature = pageConfig.nameSignature, socialButtons = pageConfig.socialButtons, topBanner = pageConfig.topBanner, exitPopupConfig = pageConfig.exitPopupConfig;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(base_template/* default */.Z, one_pager_asset_template_object_spread_props(one_pager_asset_template_object_spread({}, this.props, pageConfig), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(top_bar_component/* default */.Z, {
                            url: headerUrl,
                            loginTheme: loginTheme,
                            menuTheme: menuTheme,
                            showMenu: false,
                            stickyMode: stickyMode,
                            allowSocialButtons: socialButtons && socialButtons.show,
                            socialButtonsColor: socialButtons && socialButtons.color,
                            topBanner: topBanner,
                            maxWidth: "100%",
                            headerBackgroundColor: "transparent"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OnePagerAssetContentComponent, one_pager_asset_template_object_spread({}, pageConfig))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(core_addons_component/* default */.Z, {
                            exitPopup: exitPopup,
                            exitPopupConfig: exitPopupConfig
                        })
                    ]
                }));
            }
        }
    ]);
    return OnePagerAssetTemplate;
}(react.PureComponent);

OnePagerAssetTemplate.defaultProps = {
    headerUrl: "https://monday.com/",
    title: "monday.com",
    description: "",
    exitPopup: true,
    menuTheme: "",
    loginTheme: ""
};


/***/ }),

/***/ 31182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "nQ": function() { return /* binding */ LocalizedResourcesLinks; },
/* harmony export */   "yt": function() { return /* binding */ LocalizedOurProductFooterLinksV2; }
/* harmony export */ });
/* unused harmony export getLocalizedLink */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var _constants_localization__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72632);
/* harmony import */ var _constants_localization__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_constants_localization__WEBPACK_IMPORTED_MODULE_0__);


var SPANISH_HELP_CENTER_LINK = "//support.monday.com/hc/es";
var FRENCH_HELP_CENTER_LINK = "//support.monday.com/hc/fr";
var PORTUGEESE_HELP_CENTER_LINK = "//support.monday.com/hc/es";
var GERMAN_HELP_CENTER_LINK = "//support.monday.com/hc/de";
var JAPANESE_HELP_CENTER_LINK = "//support.monday.com/hc/ja";
var SPANISH_BLOG_LINK = "//monday.com/blog/es/";
var PORTUGEESE_BLOG_LINK = "//monday.com/blog/pt/";
var FRENCH_BLOG_LINK = "//monday.com/blog/fr/";
var GERMAN_BLOG_LINK = "//monday.com/blog/de/";
var JAPANESE_BLOG_LINK = "//monday.com/blog/ja/";
var SPANISH_WORK_OS_LINK = "//monday.com/blog/es/work-os/";
var PORTUGEESE_WORK_OS_LINK = "//monday.com/blog/pt/work-os-uma-plataforma-para-o-futuro-do-trabalho/";
var FRENCH_WORK_OS_LINK = "//monday.com/blog/fr/le-work-os-lavenir-du-travail/";
var _obj;
var LocalizedResourcesLinks = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _constants_localization__WEBPACK_IMPORTED_MODULE_0__.SPANISH_LOCALE_ID, {
    "header.blog": {
        href: SPANISH_BLOG_LINK
    },
    "header.helpCenter": {
        href: SPANISH_HELP_CENTER_LINK
    },
    "footer.blog": {
        href: SPANISH_BLOG_LINK,
        openInNewTab: true
    },
    "footer.helpCenter": {
        href: SPANISH_HELP_CENTER_LINK,
        openInNewTab: true
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _constants_localization__WEBPACK_IMPORTED_MODULE_0__.PORTUGEESE_LOCALE_ID, {
    "header.blog": {
        href: PORTUGEESE_BLOG_LINK
    },
    "header.helpCenter": {
        href: PORTUGEESE_HELP_CENTER_LINK
    },
    "footer.blog": {
        href: PORTUGEESE_BLOG_LINK,
        openInNewTab: true
    },
    "footer.helpCenter": {
        href: PORTUGEESE_HELP_CENTER_LINK,
        openInNewTab: true
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _constants_localization__WEBPACK_IMPORTED_MODULE_0__.FRENCH_LOCALE_ID, {
    "header.blog": {
        href: FRENCH_BLOG_LINK
    },
    "header.helpCenter": {
        href: FRENCH_HELP_CENTER_LINK
    },
    "footer.blog": {
        href: FRENCH_BLOG_LINK,
        openInNewTab: true
    },
    "footer.helpCenter": {
        href: FRENCH_HELP_CENTER_LINK,
        openInNewTab: true
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _constants_localization__WEBPACK_IMPORTED_MODULE_0__.GERMAN_LOCALE_ID, {
    "header.blog": {
        href: GERMAN_BLOG_LINK
    },
    "header.helpCenter": {
        href: GERMAN_HELP_CENTER_LINK
    },
    "footer.blog": {
        href: GERMAN_BLOG_LINK,
        openInNewTab: true
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _constants_localization__WEBPACK_IMPORTED_MODULE_0__.JAPANESE_LOCALE_ID, {
    "header.blog": {
        href: JAPANESE_BLOG_LINK
    },
    "header.helpCenter": {
        href: JAPANESE_HELP_CENTER_LINK
    },
    "footer.blog": {
        href: JAPANESE_BLOG_LINK,
        openInNewTab: true
    }
}), _obj);
var DEFAULT_LINKS = {
    "header.blog": {
        href: "//monday.com/blog"
    }
};
var _obj1;
var LocalizedOurProductFooterLinksV2 = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, _constants_localization__WEBPACK_IMPORTED_MODULE_0__.SPANISH_LOCALE_ID, {
    "footer.workOS": SPANISH_WORK_OS_LINK
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, _constants_localization__WEBPACK_IMPORTED_MODULE_0__.PORTUGEESE_LOCALE_ID, {
    "footer.workOS": PORTUGEESE_WORK_OS_LINK
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, _constants_localization__WEBPACK_IMPORTED_MODULE_0__.FRENCH_LOCALE_ID, {
    "footer.workOS": FRENCH_WORK_OS_LINK
}), _obj1);
var getLocalizedLink = function(link, localeId) {
    var _DEFAULT_LINKS_link;
    var localizedLinks = LocalizedResourcesLinks[localeId];
    return localizedLinks && localizedLinks[link] ? localizedLinks[link].href : ((_DEFAULT_LINKS_link = DEFAULT_LINKS[link]) === null || _DEFAULT_LINKS_link === void 0 ? void 0 : _DEFAULT_LINKS_link.href) || link;
};


/***/ }),

/***/ 30513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ MOBILE_VERSIONS; }
/* harmony export */ });
var MOBILE_VERSIONS = {
    MOBILE_ASSET: "MOBILE_ASSET",
    MOBILE_BACKGROUND_GIF: "MOBILE_BACKGROUND_GIF"
};


/***/ }),

/***/ 95333:
/***/ (function(module) {

"use strict";
//  names of translation projects supported by cluster service

var HOMEPAGE_PROJECT = "homepage"; // All the website static translations
var GENERATOR_PROJECT = "lp_generator"; // Page translations jobs data
var ALL_TRANSLATION_PROJECTS = [
    HOMEPAGE_PROJECT,
    GENERATOR_PROJECT
];
module.exports = {
    HOMEPAGE_PROJECT: HOMEPAGE_PROJECT,
    GENERATOR_PROJECT: GENERATOR_PROJECT,
    ALL_TRANSLATION_PROJECTS: ALL_TRANSLATION_PROJECTS
};


/***/ }),

/***/ 79813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ BaseTemplatePage; },
/* harmony export */   "getSerializedServerProps": function() { return /* binding */ getSerializedServerProps; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12918);
/* harmony import */ var server_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24730);
/* harmony import */ var server_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(server_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_3__);








var isObject = function(obj) {
    return obj && typeof obj === "object";
};
var __N_SSP = true;
var getSerializedServerProps = function(serverProps) {
    return Object.keys(serverProps).reduce(function(result, prop) {
        if (isObject(serverProps[prop])) {
            var objectKeys = Object.keys(serverProps[prop]);
            for(var i = 0; i < objectKeys.length; i++){
                var key = objectKeys[i];
                if (serverProps[prop][key] === undefined) {
                    delete serverProps[prop][key];
                }
            }
        }
        if (serverProps[prop]) {
            result[prop] = serverProps[prop];
        }
        return result;
    }, {});
};
var BaseTemplatePage = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(BaseTemplatePage, PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(BaseTemplatePage);
    function BaseTemplatePage() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, BaseTemplatePage);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(BaseTemplatePage, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var pageConfig = this.props.pageConfig;
                // Track ab test if the landing page is in test.
                if (pageConfig && pageConfig.abTestVariant && pageConfig.abTestName) {
                    BigBrain("track", pageConfig.abTestName, {
                        ab_test: pageConfig.abTestVariant
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var errorCode = this.props.errorCode;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_error__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    statusCode: errorCode
                });
            }
        }
    ]);
    return BaseTemplatePage;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);



/***/ }),

/***/ 44353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ OnePagerAssetTemplatePage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_templates_one_pager_asset_template_one_pager_asset_template__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87355);
/* harmony import */ var _base_template_page__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79813);




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}



var OnePagerAssetTemplatePage = /*#__PURE__*/ function(BaseTemplatePage) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(OnePagerAssetTemplatePage, BaseTemplatePage);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(OnePagerAssetTemplatePage);
    function OnePagerAssetTemplatePage() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, OnePagerAssetTemplatePage);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(OnePagerAssetTemplatePage, [
        {
            key: "render",
            value: function render() {
                var errorCode = this.props.errorCode;
                if (errorCode) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Error, {
                    statusCode: errorCode
                });
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_templates_one_pager_asset_template_one_pager_asset_template__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _object_spread({}, this.props));
            }
        }
    ]);
    return OnePagerAssetTemplatePage;
}(_base_template_page__WEBPACK_IMPORTED_MODULE_2__["default"]);
var __N_SSP = true;



/***/ }),

/***/ 87917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PaletteIconsComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/core-components/long-footer/footer-bottom-bar/palette-icons/palette-icons-component.scss.js


var StyledSinglePaletteIconComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ktd0x80"
})("display:flex;.icons-wrapper{display:flex;justify-content:space-between;align-items:center;gap:16px;}.single-app-icon-wrapper{margin-right:8px;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){margin:0 auto;padding:0;flex-wrap:wrap;margin-top:16px;.icons-wrapper:first-child{margin-right:auto;}.icons-wrapper{width:200px;margin:0 auto;margin-bottom:8px;}}");

// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./segments/desktop/core-components/long-footer/footer-bottom-bar/palette-icons/single-palette-icon/single-palette-icon-component.scss.js



var single_palette_icon_component_scss_StyledSinglePaletteIconComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e76zi3x0"
})("svg{height:24px;width:auto;}&:hover{svg{path{fill:", colors/* default */.Z[color_consts.DARK_WORK_OS_IRIS_COLOR_NAME], ";}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/long-footer/footer-bottom-bar/palette-icons/single-palette-icon/single-palette-icon-component.js







var SinglePaletteIconComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SinglePaletteIconComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SinglePaletteIconComponent);
    function SinglePaletteIconComponent() {
        (0,_class_call_check/* default */.Z)(this, SinglePaletteIconComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(SinglePaletteIconComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, clickableLink = _props.clickableLink, IconComp = _props.IconComp, title = _props.title;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(single_palette_icon_component_scss_StyledSinglePaletteIconComponent, {
                    className: "social-media-icon",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        target: "_blank",
                        href: clickableLink,
                        title: title,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "regular-icon-container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconComp, {})
                        })
                    })
                }, clickableLink);
            }
        }
    ]);
    return SinglePaletteIconComponent;
}(react.PureComponent);


;// CONCATENATED MODULE: ./segments/desktop/core-components/long-footer/footer-bottom-bar/palette-icons/palette-icons-component.js








var PaletteIconsComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(PaletteIconsComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(PaletteIconsComponent);
    function PaletteIconsComponent() {
        (0,_class_call_check/* default */.Z)(this, PaletteIconsComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(PaletteIconsComponent, [
        {
            key: "renderSocialMediaIcons",
            value: function renderSocialMediaIcons() {
                var SocialFooterLinks = this.props.SocialFooterLinks;
                var socialMediasIcons = SocialFooterLinks.links;
                return Object.keys(socialMediasIcons).map(function(key) {
                    var socialMediaIcon = socialMediasIcons[key];
                    var IconComp = socialMediaIcon.iconV2;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "single-social-icon-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SinglePaletteIconComponent, {
                            IconComp: IconComp,
                            clickableLink: socialMediaIcon.url,
                            title: socialMediaIcon.title
                        })
                    }, key);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSinglePaletteIconComponent, {
                    className: "palette-icons-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "icons-wrapper",
                        children: this.renderSocialMediaIcons()
                    })
                });
            }
        }
    ]);
    return PaletteIconsComponent;
}(react.PureComponent);



/***/ }),

/***/ 46108:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(79658)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(7222)/* ["default"] */ .Z);
var _inherits = (__webpack_require__(97788)/* ["default"] */ .Z);
var _createSuper = (__webpack_require__(37735)/* ["default"] */ .Z);
var _tsGenerator = (__webpack_require__(32401)/* ["default"] */ .Z);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var trackBigBrainEventOnServer = (__webpack_require__(75422).trackBigBrainEventOnServer);
var BaseDataProvider = (__webpack_require__(73645).BaseDataProvider);
var ProviderKeys = __webpack_require__(15071);
var REFRESH_INTERVAL_MINUTES = 15 * 60;
var URL_BASE = "https://monday.com";
var TRANSLATIONS_URL_BASE = "".concat(URL_BASE, "/localization/get");
var TranslationsDataProvider = /*#__PURE__*/ function(BaseDataProvider) {
    "use strict";
    _inherits(TranslationsDataProvider, BaseDataProvider);
    var _super = _createSuper(TranslationsDataProvider);
    function TranslationsDataProvider() {
        _classCallCheck(this, TranslationsDataProvider);
        return _super.apply(this, arguments);
    }
    _createClass(TranslationsDataProvider, [
        {
            key: "key",
            value: function key() {
                var ref = this.params(), localeId = ref.localeId, project = ref.project;
                return "".concat(ProviderKeys.TRANSLATIONS, "_locale_").concat(localeId, "_project_").concat(project);
            }
        },
        {
            key: "refreshInterval",
            value: function refreshInterval() {
                return REFRESH_INTERVAL_MINUTES;
            }
        },
        {
            key: "getData",
            value: function getData() {
                var _this = this;
                return _async_to_generator(function() {
                    var ref, localeId, project, useNewTranslationsApi, options, url, res, response, e;
                    return _tsGenerator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                ref = _this.params(), localeId = ref.localeId, project = ref.project, useNewTranslationsApi = ref.useNewTranslationsApi;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    5,
                                    ,
                                    6
                                ]);
                                options = {
                                    headers: {
                                        "Content-Type": "application/json"
                                    },
                                    method: "GET"
                                };
                                url = "".concat(TRANSLATIONS_URL_BASE, "/").concat(localeId, "/").concat(project, "/").concat(useNewTranslationsApi);
                                return [
                                    4,
                                    fetch(url, options)
                                ];
                            case 2:
                                res = _state.sent();
                                if (!(res && res.status === 200)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    res.json()
                                ];
                            case 3:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                            case 4:
                                throw new Error(res.statusText);
                            case 5:
                                e = _state.sent();
                                trackBigBrainEventOnServer("translations_internal_fetch_error", {
                                    direct_object: e.message
                                });
                                console.error(e.message);
                                throw e;
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return TranslationsDataProvider;
}(BaseDataProvider);
module.exports = TranslationsDataProvider;


/***/ }),

/***/ 24730:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _tsGenerator = (__webpack_require__(32401)/* ["default"] */ .Z);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var Sentry = __webpack_require__(48491);
var trackBigBrainEventOnServer = (__webpack_require__(75422).trackBigBrainEventOnServer);
var logException = (__webpack_require__(98989).logException);
var handleServerException = function() {
    var _ref = _async_to_generator(function(param) {
        var externalMessage, e, req, res, extraLogParams, _bbEventParams, bbEventParams;
        return _tsGenerator(this, function(_state) {
            switch(_state.label){
                case 0:
                    externalMessage = param.externalMessage, e = param.e, req = param.req, res = param.res, extraLogParams = param.extraLogParams, _bbEventParams = param.bbEventParams, bbEventParams = _bbEventParams === void 0 ? {} : _bbEventParams;
                    // 1. log to Coralogix
                    logException({
                        externalMessage: externalMessage,
                        e: e,
                        req: req,
                        res: res,
                        extraLogParams: extraLogParams
                    });
                    // 2. capture exception in Sentry
                    Sentry.captureException(e);
                    return [
                        4,
                        Sentry.flush(2000)
                    ];
                case 1:
                    _state.sent();
                    // 3. track server exception on BigBrain
                    return [
                        4,
                        trackBigBrainEventOnServer(bbEventParams.name || "server_exception", {
                            kind: bbEventParams.kind,
                            placement: req && req.url,
                            info1: e && e.message,
                            info2: req && req.params && req.params.id,
                            directObject: req && req.hostname
                        })
                    ];
                case 2:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function handleServerException(_) {
        return _ref.apply(this, arguments);
    };
}();
module.exports = {
    handleServerException: handleServerException
};


/***/ }),

/***/ 99952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Di": function() { return /* binding */ getTranslationsFromApi; },
/* harmony export */   "L8": function() { return /* binding */ getFooterComponents; },
/* harmony export */   "am": function() { return /* binding */ getHeaderComponents; }
/* harmony export */ });
/* unused harmony export isSupportedLocale */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(10092);
/* harmony import */ var _constants_links__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27639);
/* harmony import */ var _constants_localized_links__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31182);
/* harmony import */ var _constants_localization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72632);
/* harmony import */ var _constants_localization__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_constants_localization__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var services_localization_keys_all_json__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55551);
/* harmony import */ var _constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(65023);
/* harmony import */ var _server_services_bigbrain_tracking_service_bigbrain_tracking_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75422);
/* harmony import */ var _server_services_bigbrain_tracking_service_bigbrain_tracking_service__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_server_services_bigbrain_tracking_service_bigbrain_tracking_service__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _server_services_data_service_providers_base_data_provider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73645);
/* harmony import */ var _server_services_data_service_providers_base_data_provider__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_server_services_data_service_providers_base_data_provider__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _server_services_data_service_providers_translations_data_provider__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46108);
/* harmony import */ var _server_services_data_service_providers_translations_data_provider__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_server_services_data_service_providers_translations_data_provider__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _constants_translations__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95333);
/* harmony import */ var _constants_translations__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_constants_translations__WEBPACK_IMPORTED_MODULE_7__);


function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}









var getFooterComponents = function(localeId, abTests) {
    var forceGetAllComponents = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, additionalProps = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var pageClusterConfig = additionalProps.pageClusterConfig, useProductMiniSiteConfig = additionalProps.useProductMiniSiteConfig;
    var SlimFooterLinks = (0,_constants_links__WEBPACK_IMPORTED_MODULE_0__/* .slimFooterLinks */ .D80)(pageClusterConfig, {
        useProductMiniSiteConfig: useProductMiniSiteConfig
    });
    if (isSupportedLocale(localeId) && !forceGetAllComponents) return {
        MondayFooterLinks: _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .MondayFooterLinks */ .DLT,
        FeaturesFooterLinks: _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .FeaturesFooterLinks */ .YMm,
        ProductsFooterLinks: _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .ProductsFooterLinks */ .QmN,
        MoreByMondayFooterLinks: _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .MoreByMondayFooterLinks */ .AVb,
        OurProductFooterLinks: _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .OurProductFooterLinks */ .I5d,
        OurProductFooterLinksV2: updateLocalizedStaticLinks(localeId, _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .OurProductFooterLinksV2 */ .uO1, _constants_localized_links__WEBPACK_IMPORTED_MODULE_1__/* .LocalizedOurProductFooterLinksV2 */ .yt),
        OurTeamFooterLinks: _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .OurTeamFooterLinks */ .Ia5,
        OurTeamFooterLinksV2: _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .OurTeamFooterLinksV2 */ .J$8,
        ResourcesFooterLinks: updateLocalizedStaticLinks(localeId, _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .ResourcesFooterLinks */ .PvX, _constants_localized_links__WEBPACK_IMPORTED_MODULE_1__/* .LocalizedResourcesLinks */ .nQ),
        HelpFooterLinks: _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .HelpFooterLinks */ .bGv,
        NewSecurityFooterLinks: _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .NewSecurityFooterLinks */ .BeP,
        SlimFooterLinks: SlimFooterLinks
    };
    return {
        MondayFooterLinks: _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .MondayFooterLinks */ .DLT,
        FeaturesFooterLinks: _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .FeaturesFooterLinks */ .YMm,
        ProductsFooterLinks: _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .ProductsFooterLinks */ .QmN,
        MoreByMondayFooterLinks: _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .MoreByMondayFooterLinks */ .AVb,
        OurProductFooterLinks: _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .OurProductFooterLinks */ .I5d,
        OurProductFooterLinksV2: updateLocalizedStaticLinks(localeId, _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .OurProductFooterLinksV2 */ .uO1, _constants_localized_links__WEBPACK_IMPORTED_MODULE_1__/* .LocalizedOurProductFooterLinksV2 */ .yt),
        OurTeamFooterLinks: _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .OurTeamFooterLinks */ .Ia5,
        OurTeamFooterLinksV2: _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .OurTeamFooterLinksV2 */ .J$8,
        UseCasesFooterLinks: _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .UseCasesFooterLinks */ .wkx,
        UseCasesFooterLinksV2: _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .UseCasesFooterLinksV2 */ .Yly,
        ResourcesFooterLinks: updateLocalizedStaticLinks(localeId, _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .ResourcesFooterLinks */ .PvX, _constants_localized_links__WEBPACK_IMPORTED_MODULE_1__/* .LocalizedResourcesLinks */ .nQ),
        HelpFooterLinks: _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .HelpFooterLinks */ .bGv,
        NewSecurityFooterLinks: _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .NewSecurityFooterLinks */ .BeP,
        SlimFooterLinks: SlimFooterLinks
    };
};
var getHeaderComponents = function(localeId) {
    var showShortHeader = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (isSupportedLocale(localeId)) return _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .LocalizedHeader */ .kov;
    return showShortHeader ? _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .ShortHeader */ .ha3 : _constants_links__WEBPACK_IMPORTED_MODULE_0__/* .Header */ .h4i;
};
var isSupportedLocale = function(localeId) {
    var filteredArray = _constants_localization__WEBPACK_IMPORTED_MODULE_2__.SUPPORTED_LOCALE_IDS.filter(function(supportedLocale) {
        return supportedLocale === localeId;
    });
    return filteredArray.length > 0;
};
var updateLocalizedStaticLinks = function(localeId, resourceLinks, allLocalesLocalizedLinks) {
    var localeLocalizedLinks = allLocalesLocalizedLinks[localeId];
    var localizedLinks = _object_spread({}, resourceLinks.links, localeLocalizedLinks);
    // Filter the localizedLinks to only include keys that start with "footer"
    var filteredLinks = Object.fromEntries(Object.entries(localizedLinks).filter(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
        return key.startsWith("footer");
    }));
    return _object_spread_props(_object_spread({}, resourceLinks), {
        links: filteredLinks
    });
};
var getTranslationsFromApi = function() {
    var _ref = _async_to_generator(function(localeId, useNewTranslationsApi) {
        var translations, provider, exception;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!isSupportedLocale(localeId)) return [
                        2,
                        services_localization_keys_all_json__WEBPACK_IMPORTED_MODULE_3__
                    ];
                    translations = {};
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    provider = new (_server_services_data_service_providers_translations_data_provider__WEBPACK_IMPORTED_MODULE_6___default())({
                        localeId: localeId,
                        project: _constants_translations__WEBPACK_IMPORTED_MODULE_7__.HOMEPAGE_PROJECT,
                        useNewTranslationsApi: useNewTranslationsApi
                    });
                    return [
                        4,
                        (0,_server_services_data_service_providers_base_data_provider__WEBPACK_IMPORTED_MODULE_5__.getCachedData)(provider)
                    ];
                case 2:
                    translations = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    exception = _state.sent();
                    (0,_server_services_bigbrain_tracking_service_bigbrain_tracking_service__WEBPACK_IMPORTED_MODULE_4__.trackBigBrainEventOnServer)(_constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_10__.TRANSLATIONS_INTERNAL_ERROR, {
                        info1: exception.message,
                        info2: localeId
                    });
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2,
                        _object_spread({}, services_localization_keys_all_json__WEBPACK_IMPORTED_MODULE_3__, translations)
                    ];
            }
        });
    });
    return function getTranslationsFromApi(localeId, useNewTranslationsApi) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 12918:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(89185)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [296,7229,6602,390,8559,5365,4778,1489,9359,4362,5657,932,4494,4961,1068,3211,9160,1360,2849,6022,3203,5338,1882,9112,4991,8689,9774,2888,179], function() { return __webpack_exec__(78330); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);